import { termsFr } from './terms.fr';
import { termsEn } from './terms.en';
import { privacyFr } from './privacy.fr';
import { privacyEn } from './privacy.en';

/**
 * @param {'terms' | 'privacy'} doc
 * @param {'fr' | 'en'} language
 */
export function getLegalDocument(doc, language) {
  const lang = language === 'en' ? 'en' : 'fr';
  if (doc === 'privacy') {
    return lang === 'en' ? privacyEn : privacyFr;
  }
  return lang === 'en' ? termsEn : termsFr;
}
